export default "__VITE_ASSET__QPw25dIN__"